// @flow
import React from 'react';
import {
  Box,
  Input,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { MAX_OFFERS } from '../../RenewalOfferForm/helpers';

type RenderTermLengthProps = {
  termLength: string,
};

export const RenderTermLength = ({ termLength }: RenderTermLengthProps) => (
  <Box flex={1} data-test="previous-offer-term">
    <Input value={`${termLength}`} disabled fullWidth />
  </Box>
);

type Props = {
  termLengths: Array<string>,
};

const OfferTermsRow = ({ termLengths }: Props) => (
  <>
    {Array.from({ length: MAX_OFFERS }, (_, i) => i).map((i) => (
      <RenderTermLength key={i} termLength={termLengths[i]} />
    ))}
    <Box sx={{ width: 40, flexShrink: 0 }} />
  </>
);

export default OfferTermsRow;
